import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

export default function ParentHomePage() {
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get('/parent/children/');
        if (!cancelled) setChildren(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        if (!cancelled) {
          const msg = e.response?.data?.detail || 'Не удалось загрузить список детей.';
          setError(typeof msg === 'string' ? msg : 'Не удалось загрузить список детей.');
          setChildren([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="parent-home-page">
      <div className="page-header">
        <h1>Кабинет родителя</h1>
        <p className="page-subtitle">
          План занятий и журнал попыток ребёнка. Оплата — общий семейный счёт.
        </p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <section className="billing-section">
        <h2>Оплата</h2>
        <p className="text-secondary">
          Баланс, пополнение и подтверждение занятий — на странице{' '}
          <Link to="/billing">Баланс</Link>.
        </p>
      </section>

      <section className="billing-section">
        <h2>Дети</h2>
        {children.length === 0 ? (
          <p className="text-secondary">
            Пока нет привязанных детей. Связь родитель–ученик создаётся в админке сайта.
          </p>
        ) : (
          <ul className="parent-child-list">
            {children.map((child) => (
              <li key={child.id} className="parent-child-card">
                <div className="parent-child-card-title">
                  {child.display_name}
                  <span className="text-secondary"> @{child.username}</span>
                </div>
                <div className="parent-child-card-links">
                  <Link
                    to={`/my-schedule?student_id=${child.id}`}
                    className="btn btn-primary btn-sm"
                  >
                    Расписание
                  </Link>
                  <Link
                    to={`/parent/children/${child.id}/topic-progress`}
                    className="btn btn-outline btn-sm"
                  >
                    План занятий
                  </Link>
                  <Link
                    to={`/parent/children/${child.id}/activity`}
                    className="btn btn-outline btn-sm"
                  >
                    Журнал попыток
                  </Link>
                  <Link to="/billing" className="btn btn-outline btn-sm">
                    Оплата
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
